// extracted by mini-css-extract-plugin
module.exports = {"blockHeader":"css_blockHeader__1Jw7D","headerActions":"css_headerActions__353mE","table":"css_table__1EyRV"};